import { useEffect, useState } from 'react';
import {Modal, Form, Select, InputNumber, Button, Typography, notification} from 'antd';
import merchantSettlementService from "../../../services/ewallet_integration/merchant_settlement.service";
import parkService from "../../../services/config/park.service";

const { Text } = Typography;

const MerchantSettlementModal = (props) => {
    const { visible, onClose , initialData = null, merchants = [], merchantOptions = [], refresh } = props;
    const [form] = Form.useForm();
    const [filteredMerchants, setFilteredMerchants] = useState([]);
    const [selectedMerchant, setSelectedMerchant] = useState(null);
    const [selectedMerchantName, setSelectedMerchantName] = useState('');


    useEffect(() => {
        if (initialData) {
            form.setFieldsValue({
                merchant_id: initialData.merchant_id,
                amount: initialData.amount,
            });

            const found = merchants.find(m => m.merchant_id === initialData.merchant_id);
            if (found) setSelectedMerchant(found);
        } else {
            form.resetFields();
            setSelectedMerchant(null);
        }
    }, [initialData, form, merchants]);

    const handleMerchantSearch = (searchText) => {
        const filtered = merchantOptions.filter((m) =>
            m.label.toLowerCase().includes(searchText.toLowerCase())
        );
        setFilteredMerchants(filtered);
    };

    const onChangeMerchant = (value, option) => {
        const selected = merchants.find(m => m.merchant_id === value);
        setSelectedMerchant(selected); // <-- this is missing!
    };



    const handleFinish = async (values) => {
        try {
            const response = await merchantSettlementService.createMerchantSettlement(values);

            notification.success({
                message: 'Settlement Created',
                description: ` settled successfully.`,
            });
            refresh();
            onClose();
        } catch (err) {
            notification.error({
                message: 'Settlement Failed',
                description: err?.response?.data?.message || 'Something went wrong while creating settlement.',
            });
        }

        form.resetFields();
        setSelectedMerchant(null);
    };

    return (
        <Modal
            title={initialData ? 'Edit Settlement' : 'Create Settlement'}
            open={visible}
            onCancel={onClose}
            footer={null}
            destroyOnClose
        >
            <Form form={form} layout="vertical" onFinish={handleFinish}>
                <Form.Item
                    label="Merchant"
                    name="merchant_id"
                    rules={[{ required: true, message: 'Please select a merchant' }]}
                >
                    <Select
                        showSearch
                        placeholder="Search merchant"
                        optionFilterProp="label"
                        onChange={onChangeMerchant}
                        onSearch={handleMerchantSearch}
                        filterOption={(input, option) =>
                            option.label.toLowerCase().includes(input.toLowerCase())
                        }
                        options={filteredMerchants.length ? filteredMerchants : merchantOptions}
                        style={{ width: '100%' }}
                    />
                </Form.Item>


                {selectedMerchant && (
                    <div style={{ background: '#fafafa', padding: 12, borderRadius: 6, marginBottom: 16 }}>
                        <Text><strong>Name:</strong> {selectedMerchant.name}</Text><br />
                        <Text><strong>Wallet:</strong> {selectedMerchant.wallet?.name}</Text><br />
                        <Text><strong>Balance:</strong> {selectedMerchant.wallet?.melon_balance} Melon</Text>
                    </div>
                )}

                <Form.Item
                    label="Amount"
                    name="amount"
                    rules={[{ required: true, message: 'Please enter amount' }]}
                >
                    <InputNumber
                        min={0}
                        max={selectedMerchant ? parseFloat(selectedMerchant.wallet?.melon_balance || 0) * 0.9 : undefined}
                        step={0.01}
                        precision={2}
                        style={{ width: '100%' }}
                        placeholder="Enter amount (max 90% of balance)"
                    />

                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" block>
                        {initialData ? 'Update' : 'Settle'}
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default MerchantSettlementModal;
